// src/widgets/admin/CreateAdminDialog.js
import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
    Alert,
} from '@mui/material';
import RequestService from '../../services/RequestService';

const CreateAdminDialog = ({ open, onClose, company, email, onSuccess }) => {
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);

    const handleSubmit = async () => {
        if (!name || !password) {
            setError('Preencha todos os campos');
            return;
        }

        try {
            await RequestService.createAdminForCompany(company.id, {
                name,
                email,
                password,
            });
            onSuccess();
            onClose();
        } catch (err) {
            console.error('Erro ao criar administrador:', err);
            setError('Erro ao criar administrador');
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Criar Administrador</DialogTitle>
            <DialogContent>
                <Box display="flex" flexDirection="column" gap={2} mt={1}>
                    <TextField
                        label="Nome"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        fullWidth
                    />
                    <TextField
                        label="E-mail"
                        value={email}
                        disabled
                        fullWidth
                    />
                    <TextField
                        label="Senha"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        type="password"
                        fullWidth
                    />
                    {error && <Alert severity="error">{error}</Alert>}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    Cancelar
                </Button>
                <Button onClick={handleSubmit} variant="contained">
                    Criar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateAdminDialog;
